// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__zBR1k","wrapper":"style_wrapper__bWSRB"};